import { DataTypes } from "@shared/src/enums/DataTypes";

export class CustomTableColumnData {
    public columnName: string;
    public dataType: DataTypes;
    public column: number;
    public order: number;
    public multiplePuntIComa: boolean;
}
